export * from './hotelsSearched'
